<app-group-header [Heading]="'Z-Richtung' | translate"
                  [chart]="chart"
                  [info]="info"
                  [noChart]="true"
                  (chartEvent)="getChartEvent($event)"
                  (infoEvent)="getInfoEvent($event)">
</app-group-header>

<div class="card-group">

    <app-default-card class="card" style="border: none; border-radius: unset;"
                      [Heading]="'Anzahl Positionierung Z-Richtung' | translate"
                      [Error]="Positioning?.isError"
                      [ErrorLevel]="Positioning?.status"
                      [showChart]="chart"
                      [showInfo]="info"
                      [Values]="[Positioning?.TimeseriesData]"
                      [Legend]="['Anzahl Positionierung Z-Richtung' | translate]"
                      [Info]="'Anzahl Positionierung Z-Richtung.'"
                      [resizeEvent]="childResizeEvent"></app-default-card>


    <app-default-card class="card" style="border: none; border-radius: unset;"
                      [Heading]="'Strecke Z-Richtung' | translate"
                      [Error]="Distance?.isError"
                      [ErrorLevel]="Distance?.status"
                      [showChart]="chart"
                      [showInfo]="info"
                      [Values]="[Distance?.TimeseriesData]"
                      [customTemplate]="custom"
                      [Unit]="'m'"
                      [MaintenanceValue]="Distance?.ValueLastService"
                      [Legend]="['Strecke Z-Richtung' | translate]"
                      [resizeEvent]="childResizeEvent"></app-default-card>

    <ng-template #custom>
        {{Distance?.TimeseriesData?.currentDatapoint?.value / 100 | number:'1.0-2'}} km
    </ng-template>

</div>
